import { render, staticRenderFns } from "./VFormItemRangeTime.vue?vue&type=template&id=601861a6&"
import script from "./VFormItemRangeTime.vue?vue&type=script&lang=js&"
export * from "./VFormItemRangeTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports